<template>
<v-container class="py-0">
  <v-row wrap>
    <v-col cols="6" class="py-1">
      <DisplayField label="Policy" :value="policyTitle" />
    </v-col>
    <v-col cols="6" class="py-1">
      <DisplayField label="Line Of Business" :value="lobCodes[lobCode]" />
    </v-col>
  </v-row>
</v-container>
</template>

<style>
</style>

<script>
import { mapState } from 'vuex';
import DisplayField from '@/components/Shared/DisplayField.vue';
import lobCodeService from '@/services/clientViewer/lobCodeService.js';

export default {
  name: 'Policies',
  components: {
    DisplayField
  },
  computed: {
    ...mapState(['policyTitle', 'selectedLineOfBusinessCode']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    },
    viewMoreText: function () {
      return this.viewingMore ? 'View Less' : 'View More';
    },
    lobCodes: function () {
      return lobCodeService.lobCodes;
    }
  },
  methods: {
    toggleView: function () {
      this.viewingMore = !this.viewingMore;
    }
  }
};
</script>
